'use client'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

// Musteriye acik Ring Servis formu buradaydi — kullanici talebiyle (2026-08-09) kaldirildi:
// musteriler artik ring talebi giremiyor, ring servisi sadece operator panelinden (dashboard
// icindeki "Ring Servis Talebi" butonu) kullaniliyor. Ileride tekrar acilabilir diye backend
// tarafindaki genel (auth gerektirmeyen) ring uc noktalari (app/api/v1/public.py) OLDUGU GIBI
// birakildi, sadece bu sayfa (ve otoparkpaneli.com'daki linkler) kaldirildi.
export default function HomePage() {
  const router = useRouter()

  useEffect(() => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('access_token') : null
    router.replace(token ? '/dashboard' : '/login')
  }, [router])

  return null
}
